/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function navbar(theme, ownerState) {
    const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { transparentNavbar, absolute, light, darkMode } = ownerState;

    const { dark, white, text, transparent, background } = palette;
    const { navbarBoxShadow } = boxShadows;
    const { pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        boxShadow: transparentNavbar || absolute ? "none" : navbarBoxShadow,
        // backgroundColor: transparentNavbar || absolute ? `${transparent.main} !important` : white.main,
        backgroundColor: darkMode ? (transparentNavbar || absolute ? `${transparent.main} !important` : background.dark) : transparentNavbar || absolute ? `${transparent.main} !important` : white.main,

        color: () => {
            let color;

            if (light) {
                color = white.main;
            } else if (transparentNavbar) {
                color = text.main;
            } else {
                color = dark.main;
            }

            return color;
        },
        top: absolute ? 0 : pxToRem(12),
        minHeight: pxToRem(75),
        display: "grid",
        alignItems: "center",
        borderRadius: borderRadius.xl,
        paddingTop: pxToRem(8),
        paddingBottom: pxToRem(8),
        paddingRight: absolute ? pxToRem(8) : 0,
        paddingLeft: absolute ? pxToRem(16) : 0,

        "& > *": {
            transition: transitions.create("all", {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
            }),
        },

        "& .MuiToolbar-root": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            [breakpoints.up("sm")]: {
                minHeight: "auto",
                padding: `${pxToRem(4)} ${pxToRem(16)}`,
            },
        },
    };
}

const navbarContainer = ({ breakpoints }) => ({
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    pt: 0.5,
    pb: 0.5,

    [breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
        paddingTop: "0",
        paddingBottom: "0",
    },
});

const navbarRowLeft = ({ breakpoints }, { isMini }) => ({
    display: "none",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    // backgroundColor: '#ff0000',

    [breakpoints.up("md")]: {
        display: "flex",
        // justifyContent: isMini ? "space-between" : "stretch",
        width: isMini ? "100%" : "max-content",
    },

    [breakpoints.up("xl")]: {
        display: "flex",
        // justifyContent: "stretch !important",
        width: "max-content !important",
    },
});

const navbarRowRight = ({ breakpoints }, { isMini }) => ({
    display: "flex",
    flexDirection: 'row',
    // alignItems: "center",
    justifyContent: "space-between !important",
    width: "100%",
    // backgroundColor: '#f0ffff',


    [breakpoints.up("md")]: {
        justifyContent: "flex-end !important",
        width: isMini ? "100%" : "max-content",
        // backgroundColor: '#1234abcd'
    },

    [breakpoints.up("xl")]: {
        // justifyContent: "space-between !important",
        width: "max-content !important",
    },
});

const navbarIconButton = ({ typography: { size }, breakpoints }) => ({
    // px: 0.75,
    cursor: 'pointer',
    display: "flex",
    // backgroundColor: '#ff00ff',

    "& .material-icons, .material-icons-round": {
        fontSize: `${size.md} !important`,
    },

    "& .MuiTypography-root": {
        // display: "none",
        display: "flex",
        justifyContent: 'end',
        // textAlign: 'right',
        lineHeight: 1.2,
        ml: 0.5,
    },
});

const navbarDesktopMenu = ({ breakpoints }) => ({
    // display: "inline-block !important",
    cursor: "pointer",
    marginRight: '1rem',

    // [breakpoints.up("xl")]: {
    //     display: "inline-block !important"
    // },
});

const navbarMobileMenu = ({ breakpoints }) => ({
    display: "flex",
    lineHeight: 0,

    [breakpoints.up("md")]: {
        display: "none",
    },

    [breakpoints.up("md")]: {
        display: "none",
    },
});

export {
    navbar,
    navbarContainer,
    navbarRowLeft,
    navbarRowRight,
    navbarIconButton,
    navbarDesktopMenu,
    navbarMobileMenu,
};
